<template>
  <div>
    <v-dialog v-model="value" persistent max-width="60%">
      <v-card class="elevation-16 mx-auto">
        <v-card-title class="headline" primary-title>
          <span >{{ $t('common.list') }}</span>
        </v-card-title>

        <v-card-text>
          <v-data-table :headers="headers" :items="data" :search="search" class="elevation-1" hide-default-footer :page.sync="page" :loading="loading" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
            <template v-slot:[`item.code`]="{ item }">
              <span class="text-no-wrap">{{ item.code }}</span>
            </template>

            <template v-slot:[`item.designRequest.code`]="{ item }">
              <span class="text-no-wrap">{{ item.designRequest.code }}</span>
            </template>

            <template v-slot:[`item.designRequest.requestTitle`]="{ item }">
              <span class="contentTitle">
                {{ item.designRequest.requestTitle + (item.designRequest.orderUnit ? (' - ' + item.designRequest.orderUnit.name) : '') }}
              </span>
            </template>

            <template v-slot:no-data>
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
          </v-data-table>

          <div class="text-center pt-2">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="closeDialog">{{ $t('common.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';
// import moment from "moment";

export default {
  name: 'detail-effort-dialog',

  props: {
    value: Boolean,
    data: Array
  },


  data: ()=> ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    loading: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 5,

    search: '',

    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index',},
      {text: i18n.t('design_manager.code_manufacture'), sortable: false, value: 'code'},
      {text: i18n.t('design_manager.code'), sortable: false, value: 'designRequest.code'},
      {text: i18n.t('design_manager.name'), sortable: false, value: 'designRequest.requestTitle'},
    ],
    desserts: [],
  }),

  computed: {

  },

  watch: {

  },

  mounted () {
  },

  async created () {
  },


  methods: {
    closeDialog() {
      this.$emit('closeDialog', false);
    },
  }
}
</script>

<style scoped>
.v-text-field .v-input__control .v-input__slot {
  min-height: 45px !important;
  /* display: flex !important; */
  align-items: center !important;
}
</style>
